import React, { useRef, useEffect, useState, useContext } from "react";
import { FormikProps, FormikValues } from "formik";

import AccountSubHeader from "../account/accountSubHeader/accountSubheader";
import DiscountCodeForm from "../discountCodeForm/DiscountCodeForm";
import Button from "../button/Button";
import { fetchPostJSON } from "../../utils/api-helpers";

import styles from "./discountCode.module.css";

interface Props {
  subscriptionId: string;
}

const DiscountCode: React.FC<Props> = ({ subscriptionId }): JSX.Element => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [message, setMessage] = useState<string>(null);
  const customSubmitRef = useRef<FormikProps<FormikValues>>(null);

  const handleApplyCode = async ({ code }) => {
    //handle the application of the discount code
    try {
      setIsLoading(true);
      // send coupon + subscription id to stripe
      const response = await fetchPostJSON("/api/apply_coupon", {
        subscriptionId: subscriptionId,
        code: code,
      });

      if (response.statusCode === 500 || response.statusCode === 400) {
        // handle fail
        setMessage(
          "There was a problem applying your discount code, please try again or contact OR if the problem persists."
        );
        return;
      } else {
        // handle success
        setMessage("Discount code applied successfully!");
        return;
      }

      setIsLoading(false);
    } catch (error) {
      console.log("error in checkout process", error);
      setMessage(
        "There was a problem applying your discount code, please try again or contact OR if the problem persists."
      );
    }
  };

  const handleSubmit = () => {
    customSubmitRef?.current?.handleSubmit();
  };

  return (
    <div>
      <AccountSubHeader title="Apply discount code" />
      <div className={styles.container}>
        <DiscountCodeForm
          handleApply={handleApplyCode}
          formSubmitRef={customSubmitRef}
        />
        <div className={styles.buttons}>
          <Button
            disabled={isLoading}
            type="submit"
            text={"Apply"}
            onClick={handleSubmit}
          />
        </div>
      </div>
      {message && <div>{message}</div>}
    </div>
  );
};

export default DiscountCode;
